import { environmentConfig } from "@src/appV2/environment";

export type ImpersonationMessage =
  | { type: "impersonation:success" }
  | { type: "impersonation:error"; error: string }
  | { type: "impersonation:sessionExpired" }
  | { type: "impersonation:sessionEnded" };

/**
 * Sends a postMessage to the parent window (admin app) when running in an iframe.
 * No-ops when not in an iframe.
 */
export function postMessageToParent(message: ImpersonationMessage): void {
  if (window.parent === window) {
    return;
  }

  const targetOrigin = environmentConfig.REACT_APP_ADMIN_WEB_APP_URL;
  if (!targetOrigin) {
    return;
  }

  window.parent.postMessage(message, new URL(targetOrigin).origin);
}
